export default function Header() {
  return (
    <header className="site-header">
      <div className="site-header__brand">San Juan</div>
      <nav className="site-header__nav" aria-label="Primary">
        <a href="#experiences" className="tlink" data-cursor="expand">
          Experiences
        </a>
        <a href="#sanctuary" className="tlink" data-cursor="expand">
          Sanctuary
        </a>
        <a href="#journey" className="tlink" data-cursor="expand">
          Journey
        </a>
      </nav>
      <a href="#reserve" className="site-header__cta tlink" data-cursor="expand">
        Reserve ↗
      </a>
    </header>
  );
}